import { render, staticRenderFns } from "./noPackageDetail.vue?vue&type=template&id=878c6f0e&scoped=true"
import script from "./noPackageDetail.vue?vue&type=script&lang=ts"
export * from "./noPackageDetail.vue?vue&type=script&lang=ts"
import style0 from "./noPackageDetail.vue?vue&type=style&index=0&id=878c6f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878c6f0e",
  null
  
)

export default component.exports